import {
  Box,
  Container,
  Footer as MantineFooter,
  Group,
  Paper,
  Text,
  ThemeIcon,
  useMantineTheme
} from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { IconShieldCheck } from '@tabler/icons'
import React from 'react'

import { SocialIcons } from '@/components/widgets'
import { Site as SiteType } from '@/types'

import Menu from '../Menu'

interface Props {
  siteData: SiteType
  footerRef: React.RefObject<HTMLDivElement>
}

export default function Footer({ siteData, footerRef }: Props) {
  const theme = useMantineTheme()
  const isLg = useMediaQuery(`(max-width: ${theme.breakpoints.lg}px)`)

  return (
    <div ref={footerRef}>
      {!!siteData?.menus?.footer && <Menu content={siteData.menus.footer} />}
      <MantineFooter
        fixed={false}
        height="auto"
        py="xl"
        hidden={!siteData?.links && !siteData?.displaySiteInformation}>
        <Container size="xl">
          <Group position="apart">
            <Box>
              {siteData?.displaySiteInformation && (
                <>
                  <Text weight={700}>{siteData?.seller?.displayName}</Text>
                  {siteData?.description && (
                    <Text size="sm" color="dimmed">
                      {siteData.description}
                    </Text>
                  )}
                  {siteData?.seller?.address && (
                    <Text size="sm" color="dimmed">
                      <strong>Endereço:</strong> {siteData.seller.address}
                    </Text>
                  )}
                  {siteData?.seller?.taxDocument && (
                    <Text size="sm" color="dimmed">
                      <strong>CNPJ:</strong> {siteData.seller.taxDocument}
                    </Text>
                  )}
                </>
              )}
            </Box>
            <SocialIcons links={siteData?.links} variant="light" size="lg" />
            <Group noWrap w={isLg ? '100%' : 'auto'} position="right">
              <Paper
                withBorder
                radius="md"
                px="sm"
                py="xs"
                sx={theme => ({
                  display: 'flex',
                  alignItems: 'center',
                  gap: theme.spacing.xs,
                  backgroundColor: theme.white
                })}>
                <ThemeIcon color="green" variant="light" radius="xl" size="md">
                  <IconShieldCheck size={16} />
                </ThemeIcon>
                <Box sx={{ textAlign: 'right' }}>
                  <Text size="xs" weight={700} color="green">
                    Site 100% seguro
                  </Text>
                  <Text size="xs" color="dimmed">
                    Ambiente protegido
                  </Text>
                </Box>
              </Paper>
            </Group>
          </Group>
        </Container>
      </MantineFooter>
    </div>
  )
}
